export default "/images/window-circles.svg?2fc18c2dfddf0597c62b0298250d7607";